import { ResultObj, allFetch } from "../Domain";
import { RowData } from "../types";

// 車庫存 的欄位
export type CarStockParams = {
    cs_id: string
    store_department: string
    store_space: string
    transaction_code: string
    SIDO_no: string
    upd_time: string
    predict_arrive_port_date: string
    car_type_code: string
    year: string
    vin_no: string
    interior_color: string
    interior_code: string
    special_equipment: string
    note: string
}

export interface NewCarStockCreateParams {
    license_plate: string;
    classification: string;
    status: string;
    produce_station: string;
    dealer: string;
    store_department: string;
    store_space: string;
    car_type: string;
    format_code: string;
    year: string;
    exterior_code: string;
    exterior_color: string;
    interior_code: string;
    interior_color: string;
    day: string;
    manufacture_date: string;
    predict_offline_date: string;
    predict_dispatch_date: string;
    dispatch_date: string;
    leave_factory_date: string;
    onboard_date: string;
    predict_arrive_port_date: string;
    arrive_port_date: string;
    data_transfer_date: string;
    check_date: string;
    general_agent_dispatch_datetime: string;
    repayment_date: string;
    stock_usage: string;
    brand: string;
    SIDO_no: string;
    vin_no: string;
    engine_no: string;
    body_code_no: string;
    transaction_type: string;
    transaction_code: string;
    car_owner_name: string;
    saler_name: string;
    transaction_datetime: string;
    transaction_date: string;
    employee_name: string;
    reserve_reason: string;
    reserve_department: string;
    reserve_employee: string;
    reserve_note: string;
    stock_card_code: string;
    target: string;
    deposit_code: string;
    deposit_date: string;
    quality_control_date: string;
    quality_control_mileage: string;
    quality_control_reason: string;
    saleable: string;
    upd_time: string;
    special_equipment: string;
    note: string;
    invoice_date: string;
}

// 新增新車庫存
export const NewCarStockCreate = async (params: NewCarStockCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/NewCarStockCreate', params);



// 車庫存查詢搜尋參數
export interface CarStockSearchParams {
    order_number?: string;         // 訂單編號
    order_id?: string;             // 訂單流水號
    license_plate?: string;        // 車牌號碼
    SIDO_no?: string;              // SIDO號碼
    vin_no?: string;               // VIN號碼
    SMT_status?: string;           // 關聯SMT車狀態:在庫車、已接單、已交車
    position_id?: string;          // 據點流水號
    store_department?: string;     // 倉庫名稱
    cw_id?: string;                // 車倉儲流水號
    ct_id?: string;                // 車型流水號
    year?: string;                 // 年式
    year_age?: string;             // 年份
    visible?: string;              // 是否可見
    saleable?: 'Y' | 'N' | '';     // 是否開放銷售
    page?: number;                 // 頁碼
    num_per_page?: number;         // 一頁幾筆
}


export type CarStockSearchResItem = {
    CSML_time: string;
    CSML_user_cre_time: string;
    CSML_user_name: string;
    SIDO_no: string;
    SMT_status: string;
    arrive_port_date: string;
    car_type: string;
    car_type_name: string;
    ce_id: number;
    ci_id: number;
    classification: string;
    cre_time: string;
    cs_id: string;
    ct_id: number;
    ctep_id: number;
    ctf_id: number;
    ctfp_id: number;
    ctip_id: number;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    cw_id: string;
    exterior_code: string;
    exterior_color: string;
    format_code: string;
    format_name: string;
    interior_code: string;
    interior_color: string;
    license_plate: string;
    note: string;
    order_id: string;
    order_number: string;
    predict_arrive_port_date: string;
    saleable: string;
    special_equipment: string;
    status: string;
    store_department: string;
    store_space: string;
    upd_time: string;
    vin_no: string;
    visible: string;
    year: string;
    year_age: string;
}

// 車庫存查詢
export const CarStockSearch = async (params: CarStockSearchParams): Promise<ResultObj<CarStockSearchResItem[]>> =>
    await allFetch('CarStock/CarStockSearch', params);


export interface CarStockUpdateParams {
    cs_id: string;
    store_department: string;
    store_space: string;
    transaction_code: string;
    SIDO_no: string;
    upd_time: string;
    predict_arrive_port_date: string;
    car_type_code: string;
    year: string;
    vin_no: string;
    interior_color: string;
    interior_code: string;
    special_equipment: string;
    note: string;
}

// 修改車庫存
export const CarStockUpdate = async (params: CarStockUpdateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockUpdate', params);


export type CarStockImportSearchResItem = {
    FO: string
    body_code_no: string
    car_type: string
    exterior_code: string
    exterior_color: string
    format_code: string
    format_name: string
    interior_code: string
    interior_color: string
    invoice_date: string
    note: string
    predict_arrive_port_date: string
    reserve_status: string
    saleable: string
    special_equipment: string
    status: string
    store_department: string
    store_space: string
    transaction_code: string
    vin_no: string
    year: string
    year_age: string
}
export interface CarStockImportSearchParams {
    ct_id: string,
    cre_time: string,
    SIDO_no: string,
    vin_no: string,
    car_type: string,
    format_code: string,
    year: string,
    exterior_code: string,
    interior_code: string,
    note: string,
    arrive_port_date_start: string,
    arrive_port_date_end: string,
    special_equipment: string,
    reserve_status: string,
    page: number;
    num_per_page: number;
}

// 車庫存匯入查詢
export const CarStockImportSearch = async (params: CarStockImportSearchParams): Promise<ResultObj<CarStockImportSearchResItem>> =>
    await allFetch('CarStock/CarStockImportSearch', params);

export interface CarStockDetailParams { cs_id: string; }
export interface CarStockDetailResItem {
    SIDO_no: string;
    SMT_status: string;
    arrive_port_date: string;
    asset_type: string;
    body_code_no: string;
    brand: string;
    car_owner_name: string;
    car_species: string;
    car_type: string;
    car_type_name: string;
    ce_id: string;
    check_date: string;
    ci_id: string;
    classification: string;
    cre_time: string;
    cs_id: string;
    ct_id: string;
    ctep_id: string;
    ctf_id: string;
    ctfp_id: string;
    ctip_id: string;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    cw_id: string;
    data_transfer_date: string;
    day: string;
    dealer: string;
    deposit_code: string;
    deposit_date: string;
    dispatch_date: string;
    employee_name: string;
    engine_no: string;
    exterior_code: string;
    exterior_color: string;
    format_code: string;
    format_name: string;
    general_agent_dispatch_datetime: string;
    interior_code: string;
    interior_color: string;
    invoice_date: string;
    layoff_date: string;
    leave_factory_date: string;
    license_plate: string;
    licensed_date: string;
    manufacture_date: string;
    note: string;
    onboard_date: string;
    order_id: string;
    order_number: string;
    predict_arrive_port_date: string;
    predict_dispatch_date: string;
    predict_offline_date: string;
    produce_station: string;
    quality_control_date: string;
    quality_control_mileage: string;
    quality_control_reason: string;
    repayment_date: string;
    reserve_department: string;
    reserve_employee: string;
    reserve_employee_name: string;
    reserve_note: string;
    reserve_reason: string;
    saleable: string;
    saler_name: string;
    special_equipment: string;
    status: string;
    stock_card_code: string;
    stock_usage: string;
    store_department: string;
    store_space: string;
    suspension_date: string;
    target: string;
    transaction_code: string;
    transaction_date: string;
    transaction_datetime: string;
    transaction_type: string;
    upd_time: string;
    vin_no: string;
    visible: string;
    year: string;
    year_age: string;
}

// 車庫存細項
export const CarStockDetail = async (
    params: CarStockDetailParams
): Promise<ResultObj<CarStockDetailResItem[]>> => await allFetch('CarStock/CarStockDetail', params);



// 車庫存修改是否可見
export interface CarStockUpdateVisibleParams {
    cs_id: string;
    visible: string;
}

export const CarStockUpdateVisible = async (
    params: CarStockUpdateVisibleParams
): Promise<ResultObj> => await allFetch('CarStock/CarStockUpdateVisible', params);


// 車庫存修改是否可銷售
export interface CarStockUpdateSaleableParams {
    cs_ids: string[];
    saleable: string
}

export const CarStockUpdateSaleable = async (
    params: CarStockUpdateSaleableParams
): Promise<ResultObj> => await allFetch('CarStock/CarStockUpdateSaleable', params);


// 車庫存查詢狀態列表
export const CarStockStatusList = async (): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockStatusList');


// 查所有車庫存
export interface CarStockSearchAllParams {
    license_plate: string;
    SIDO_no: string;
    vin_no: string;
    ct_id: string;
    SMT_status: string;
    position_id: string;
    store_department: string;
    cw_id: string;
    format_code: string;
    year: string;
    page: number;
    num_per_page: number;
}

export const CarStockSearchAll = async (params: CarStockSearchAllParams): Promise<ResultObj> => await allFetch('CarStock/CarStockSearchAll', params);


export interface CarStockTransportCreateParams {
    custody_unit_id: string
    store_department: string
    predict_arrive_date: string
    cs_id: string
    cw_id: string;
    note: string;
}

// 移庫記錄新增
export const CarStockTransportCreate = async (params: CarStockTransportCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockTransportCreate', params);



export interface CarStockTransportSearchResItem {
    actual_arrive_date: string
    check_time: string
    cs_id: string
    custody_unit_id: string
    custody_unit_name: string
    cw_id: string
    id: string
    ischeck: string
    manage_ul_id: string
    manage_ul_name: string
    manage_user_id: string
    name: string
    note: string
    predict_arrive_date: string
    store_department: string
    store_space: string
    user_cre_time: string
    vin_no: string
}

export interface CarStockTransportSearchParams {
    id: string
    cs_id: string
    cw_id: string
    vin_no: string
    custody_unit_id: string
    ischeck: string
    store_department: string
    actual_arrive_date_start: string
    actual_arrive_date_end: string
    predict_arrive_date_start: string
    predict_arrive_date_end: string
    page: number;
    num_per_page: number;
}

// 移庫記錄查詢
export const CarStockTransportSearch = async (params: CarStockTransportSearchParams): Promise<ResultObj<CarStockTransportSearchResItem[]>> =>
    await allFetch('CarStock/CarStockTransportSearch', params);

export interface CarStockTransportUpdateParams {
    id: string;
    cs_id: string;
    cw_id: string;
    custody_unit_id: string;
    predict_arrive_date: string;
    store_department: string;
    note: string;
}

// 移位記錄新增
export const CarStockTransportUpdate = async (params: CarStockTransportUpdateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockTransportUpdate', params);

export interface CarStockTransportCheckParams {
    id: string;
    actual_arrive_date: string;
}

// 移位記錄確認
export const CarStockTransportCheck = async (params: CarStockTransportCheckParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockTransportCheck', params);


// 移庫歷史記錄查詢
export interface CarStockTransportLogSearchResItem {
    actual_arrive_date: string
    check_time: string
    cs_id: string
    custody_unit_id: string
    custody_unit_name: string
    cw_id: string
    id: string
    ischeck: "Y" | "N"
    manage_ul_id: string
    manage_ul_name: string
    manage_user_id: string
    name: string
    note: string
    predict_arrive_date: string
    store_department: string
    store_space: string
    user_cre_time: string
    vin_no: string
}
export interface CarStockTransportLogSearchParams {
    cs_id: string;
    vin_no: string;
    cw_id: string;
    custody_unit_id: string;
    page: number;
    num_per_page: number;
}
export const CarStockTransportLogSearch = async (params: CarStockTransportLogSearchParams): Promise<ResultObj<CarStockTransportLogSearchResItem[]>> =>
    await allFetch('CarStock/CarStockTransportLogSearch', params);

export interface CarStockShiftCreateParams {
    cs_id: string;
    cw_id: string;
    store_department: string;
    predict_arrive_date: string;
    note: string;
}

// 移位記錄新增
export const CarStockShiftCreate = async (params: CarStockShiftCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockShiftCreate', params);


export interface CarStockShiftSearchResItem {
    cre_time: string
    cs_id: string
    custody_unit_id: string
    custody_unit_name: string
    cw_id: string
    id: string
    ischeck: "Y" | "N"
    manage_ul_id: string
    manage_ul_name: string
    manage_user_id: string
    name: string
    note: string
    store_department: string
    store_space: string
    user_cre_time: string
    vin_no: string
}
export interface CarStockShiftSearchParams {
    cs_id: string,
    date_start: string,
    date_end: string,
    page: number;
    num_per_page: number;
}

// 移位記錄查詢
export const CarStockShiftSearch = async (params: CarStockShiftSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockShiftSearch', params);

export interface CarStockKeyManageBorrowParams {
    cs_id: string;
    borrow_time: string;
    borrow_user_id: string;
    note: string;
}

// 借車鑰匙
export const CarStockKeyManageBorrow = async (params: CarStockKeyManageBorrowParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyManageBorrow', params);

export interface CarStockKeyManageReturnParams {
    cskm_id: string;
    return_time: string;
    return_user_id: string;
    note: string;
}

// 還車鑰匙
export const CarStockKeyManageReturn = async (params: CarStockKeyManageReturnParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyManageReturn', params);

export interface CarStockKeyManageSearchParams {
    cs_id: string;
    borrow_time_start: string;
    borrow_time_end: string;
    borrow_user_id: string;
    return_time_start: string;
    return_time_end: string;
    return_user_id: string;
    isreturn: string;
    page: number;
    num_per_page: number;
}

// 車鑰匙紀錄查詢
export const CarStockKeyManageSearch = async (params: CarStockKeyManageSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyManageSearch', params);

export interface CarStockKeyCreateParams {
    cs_id: string;
    note: string;
}

// 新建車鑰匙
export const CarStockKeyCreate = async (params: CarStockKeyCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyCreate', params);

export interface CarStockKeySearchParams {
    cs_id: string;
    page: number;
    num_per_page: number;
}

// 查詢車鑰匙
export const CarStockKeySearch = async (params: CarStockKeySearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeySearch', params);

export interface CarStockKeyUpdateParams {
    csk_id: string;
    note: string;
}

// 修改車鑰匙
export const CarStockKeyUpdate = async (params: CarStockKeyUpdateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyUpdate', params);

export interface CarStockKeyDeleteParams {
    csk_id: string;
}

// 刪除車鑰匙
export const CarStockKeyDelete = async (params: CarStockKeyDeleteParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyDelete', params);

export interface CarStockKeyDetailParams {
    csk_id: string;
}

// 車鑰匙細項
export const CarStockKeyDetail = async (params: CarStockKeyDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockKeyDetail', params);







// 新建車QRCode
export interface CarStockQRCodeCreateParams {
    cs_id: string;
    qrcode_type: string;
    note: string;
}
export const CarStockQRCodeCreate = async (params: CarStockQRCodeCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockQRCodeCreate', params);



// 查詢車QRCode
export interface CarStockQRCodeSearchParams {
    cs_id: string;
    qrcode_type: string;
    page: number;
    num_per_page: number;
}
export interface CarStockQRCodeSearchResItem {
    cs_id: string;
    csqrc_id: string;
    note: string;
    qrcode_type: string;
    qrcode_type_name: string;
}
export const CarStockQRCodeSearch = async (params: CarStockQRCodeSearchParams): Promise<ResultObj<CarStockQRCodeSearchResItem[]>> =>
    await allFetch('CarStock/CarStockQRCodeSearch', params);


// 修改車QRCode
export interface CarStockQRCodeUpdateParams {
    csqrc_id: string;
    qrcode_type: string;
    note: string;
}
export const CarStockQRCodeUpdate = async (params: CarStockQRCodeUpdateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockQRCodeUpdate', params);


// 刪除車QRCode
export interface CarStockQRCodeDeleteParams {
    csqrc_id: string;
}
export const CarStockQRCodeDelete = async (params: CarStockQRCodeDeleteParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockQRCodeDelete', params);


// 新建車QRCode
export interface CarStockQRCodeDetailParams {
    csqrc_id: string;
}
export const CarStockQRCodeDetail = async (params: CarStockQRCodeDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockQRCodeDetail', params);


// 新建車管理紀錄
export interface CarStockManageLogCreateParams {
    cs_id: string
    detail_type: string
    id: string
    log_date: string
    log_time: string
    master_type: string
    note: string
    time: string
    user_id: string
}

export const CarStockManageLogCreate = async (params: CarStockManageLogCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockManageLogCreate', params);


// 查詢車管理紀錄
export interface CarStockManageLogSearchParams {
    cs_id: string;
    master_type: string;
    detail_type: string;
    id: string;
    time_start: string;
    time_end: string;
    user_id: string;
    note: string;
    page: number;
    num_per_page: number;
}
export interface CarStockQRCodeSearchResItem {
    cs_id: string
    csml_id: string
    detail_type: string
    detail_type_name: string
    id: string
    master_type: string
    note: string
    time: string
    user_id: string
}
export const CarStockManageLogSearch = async (params: CarStockManageLogSearchParams): Promise<ResultObj<CarStockQRCodeSearchResItem[]>> =>
    await allFetch('CarStock/CarStockManageLogSearch', params);


// 修改車管理紀錄
export interface CarStockManageLogUpdateParams {
    csml_id: string;
    id: string;
    time: string;
    user_id: string;
    note: string;
}
export const CarStockManageLogUpdate = async (params: CarStockManageLogUpdateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockManageLogUpdate', params);


// 刪除車管理紀錄
export interface CarStockManageLogDeleteParams {
    csml_id: string;
}
export const CarStockManageLogDelete = async (params: CarStockManageLogDeleteParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockManageLogDelete', params);

// 車管理紀錄細項
export interface CarStockManageLogDetailParams {
    csml_id: string;
}
export const CarStockManageLogDetail = async (params: CarStockManageLogDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockManageLogDetail', params);


// 車庫存保留查詢
export interface CarStockReserveSearchParams {
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    ci_id: string;
    year: string;
    status: string;
    arrive_port_date_start: string;
    arrive_port_date_end: string;
}
export const CarStockReserveSearch = async (params: CarStockReserveSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveSearch', params);

// 車庫存保留細項
export interface CarStockReserveDetailParams {
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    ci_id: string;
    year: string;
    status: string;
    arrive_port_date_start: string;
    arrive_port_date_end: string;
}
export const CarStockReserveDetail = async (params: CarStockReserveDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveDetail', params);


// 新建車庫存保留紀錄
export interface CarStockReserveLogCreateParams {
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    ci_id: string;
    year: string;
    status: string;
    arrive_port_date_start: string;
    arrive_port_date_end: string;
    reserve_note?: string;
}
export const CarStockReserveLogCreate = async (params: CarStockReserveLogCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveLogCreate', params);

// 車庫存保留紀錄確認
export interface CarStockReserveLogCheckParams {
    csrl_id: string;
    isagree: string;
    cs_id: string;
    reserve_reason: string;
}
export const CarStockReserveLogCheck = async (params: CarStockReserveLogCheckParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveLogCheck', params);


// 車庫存保留紀錄查詢
export interface CarStockReserveLogCancelParams {
    csrl_id: string;
}
export const CarStockReserveLogCancel = async (params: CarStockReserveLogCancelParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveLogCancel', params);


// 車庫存保留紀錄查詢
export interface CarStockReserveLogSearchParams {
    user_id: string;
    ischeck: string;
    isagree: string;
    page: string;
    num_per_page: string;
}
export const CarStockReserveLogSearch = async (params: CarStockReserveLogSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveLogSearch', params);

// 車庫存保留紀錄細項
export interface CarStockReserveLogDetailParams {
    csrl_id: string;
}
export const CarStockReserveLogDetail = async (params: CarStockReserveLogDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveLogDetail', params);

// 車庫存保留匯入主項查詢
export interface CarStockReserveImportMasterSearchResItem {
    cre_time: string
    cre_user_name: string
    cre_userid: string
    csrim_id: string
    import_count: string
    note: string
}
export interface CarStockReserveImportMasterSearchParams {
    page: number;
    num_per_page: number;
}
export const CarStockReserveImportMasterSearch = async (params: CarStockReserveImportMasterSearchParams): Promise<ResultObj<CarStockReserveImportMasterSearchResItem>> =>
    await allFetch('CarStock/CarStockReserveImportMasterSearch', params);


// 車庫存保留匯入主項細項
export interface CarStockReserveImportMasterDetailParams {
    csrim_id: string;
}
export const CarStockReserveImportMasterDetail = async (params: CarStockReserveImportMasterDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportMasterDetail', params);


// 車庫存保留匯入細項查詢(只查最新匯入的細項)
export interface CarStockReserveImportDetailSearchParams {
    csrim_id: string;
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    ci_id: string;
    year: string;
    note: string;
    arrive_port_date_start: string;
    arrive_port_date_end: string;
    special_equipment: string;
    page: string;
    num_per_page: string;
}
export const CarStockReserveImportDetailSearch = async (params: CarStockReserveImportDetailSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportDetailSearch', params);

// 車庫存保留匯入細項細項
export interface CarStockReserveImportDetailDetailParams {
    csrid_id: string;
}
export const CarStockReserveImportDetailDetail = async (params: CarStockReserveImportDetailDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportDetailDetail', params);

// 新建車庫存匯入保留紀錄
export interface CarStockReserveImportLogCreateParams {
    csrid_id: string;
    reserve_note: string;
}
export const CarStockReserveImportLogCreate = async (params: CarStockReserveImportLogCreateParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportLogCreate', params);

// 車庫存匯入保留紀錄查詢
export interface CarStockReserveImportLogSearchParams {
    user_id: string;
    ischeck: string;
    isagree: string;
    excel: string;
    page: string;
    num_per_page: string;
}
export const CarStockReserveImportLogSearch = async (params: CarStockReserveImportLogSearchParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportLogSearch', params);

// 車庫存匯入保留紀錄確認
export interface CarStockReserveImportLogCheckParams {
    csril_id: string;
    isagree: string;
    reserve_reason: string;
}
export const CarStockReserveImportLogCheck = async (params: CarStockReserveImportLogCheckParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportLogCheck', params);

// 取消車庫存匯入保留紀錄
export interface CarStockReserveImportLogCancelParams {
    csril_id: string;
}
export const CarStockReserveImportLogCancel = async (params: CarStockReserveImportLogCancelParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportLogCancel', params);

// 車庫存匯入保留紀錄細項
export interface CarStockReserveImportLogDetailParams {
    csril_id: string;
}
export const CarStockReserveImportLogDetail = async (params: CarStockReserveImportLogDetailParams): Promise<ResultObj> =>
    await allFetch('CarStock/CarStockReserveImportLogDetail', params);
